module.exports = __webpack_public_path__ + "img/office4.821ad1e6.png";